import { useEffect, useLayoutEffect } from "react";
import type { FC, ReactElement } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";

import { useTimetableData } from "utils/hooks/useTimetableData";
import { useWeekData } from "utils/hooks/useWeekData";

import { ExerciseSessionFinished } from "./ExerciseSessionFinished";
import { useSessionStorageAssignmentId } from "../../utils/hooks/useSessionStorageAssignmentId";
import { useQuery } from "utils/hooks/useQuery";

interface Props {
  children: ReactElement;
}

export const ExerciseSessionArea: FC<Props> = ({ children }) => {
  const location = useLocation();
  const { searchParams } = useQuery();
  const isDevRepeatedExercise = searchParams.get("opakovat");

  const timetable = useTimetableData();
  const { isTrainingFinished } = useWeekData(timetable.data);
  const assignmentId = useSessionStorageAssignmentId();

  // AIDEV-NOTE: layout cleanup, ne pasivní efekt — běží přímo v commitu i když Scheduler stojí.
  // Breadcrumb ukáže, jestli se strom tréninku opravdu odpojil. [TD-467]
  useLayoutEffect(
    () => () => {
      Sentry.addBreadcrumb({ category: "td467", message: "ExerciseSessionArea unmount" });
    },
    [],
  );

  useEffect(() => {
    timetable.refetch().catch(console.error);
  }, [location.key]);

  if (isTrainingFinished && !assignmentId && isDevRepeatedExercise !== "") {
    return <ExerciseSessionFinished />;
  }

  return children;
};
